import { render, staticRenderFns } from "./arrow-clockwise.vue?vue&type=template&id=f8fcc118&"
import script from "./arrow-clockwise.vue?vue&type=script&lang=js&"
export * from "./arrow-clockwise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports